<template lang="html">
  <div>
    <v-row v-if="!showProfile">
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="search"
                  placeholder="Key in event name here"
                  append-icon="search"
                  label="Search event"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              
              <v-col
                v-if="$hasPermissionTo(['create events'])"
                cols="2"
                offset-md="2"
              >
                <event-dialog-create
                  @created="loadEvents"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-row>
            <v-col
              v-for="(event,i) in events"
              :key="i"
              cols="3"
              class=""
            >
              <v-card
                class="mx-auto px-0"
                max-width="370"
              >                
                <v-img
                  :src="event.image_url"
                  height="194"
                  @click="viewPhotos(event)"
                />

                <v-list-item>
                  <v-list-item-content>                      
                    <v-list-item-title class="mb-1 font-weight-bold text-truncate">
                      {{ event.name }}
                    </v-list-item-title>

                    <v-list-item-subtitle class="text-truncate">
                      Date: 
                      <span v-if="event.start_date && event.end_date">{{ $moment(event.start_date).format('D MMM YYYY') }} - {{ $moment(event.end_date).format('D MMM YYYY') }}</span>
                      <span v-else>N/A</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="text-truncate">
                      {{ event.description }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
             
                <event-dialog-edit
                  v-if="$hasPermissionTo(['update events'])"
                  :event="event"
                  @updated="loadEvents"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <event-container-view
      v-if="showProfile"
      :event="event"
    >
      <template v-slot:navigation>
        <v-breadcrumbs 
          :items="navItems" 
          divider="/"
          class="py-0"
        >
          <template v-slot:item="props">
            <a  
              :class="{ 
                'disabled': props.item.disabled, 
              }"       
              @click="updatePage"
            >{{ props.item.text }}</a>
          </template>
        </v-breadcrumbs>
      </template>
    </event-container-view>
  </div>
</template>

<script>
  export default {
    components: {
      EventContainerView: () => import('@/components/event/ContainerView'),
      EventDialogCreate: () => import('@/components/event/DialogCreate'),
      EventDialogEdit: () => import('@/components/event/DialogEdit'),
    },
    data: () => {
      return {
        navItems: [
          {
            text: 'Overview',
            disabled: false,
            to: { path: '/events' }, 
            exact: true,
          },
          {
            text: 'Event',
            disabled: true,
          },
        ],
        search: '',
        showProfile: false,
        events: [],
        event: null,
        loading: false,
      }
    },
    created () {
      this.loadEvents()
    },
    methods: {
      updatePage () {
        this.loadEvents()
        this.showProfile = false
      },
      viewPhotos (event) {
        this.event = event
        this.showProfile = true
      },
      loadEvents () {
        this.loading = true

        this.$api.events().list()
          .then(res => {
            this.events = _.orderBy(res.data, ['created_at'], ['desc'])  
            console.log(res.data)
            this.loading = false
          })
      },
    },
  }
</script>

<style lang='css' scoped>
.disabled {
    color: grey;
    pointer-events: none;
}

.overflow {
  height:80vh;
}

</style>
